<template>
    <div id="header">
        <div class="fixed-top">
            <div class="nav-wrapper">
                <div class="container">
                    <b-navbar toggleable="md">
                        <b-nav-toggle target="nav_collapse"></b-nav-toggle>

                        <div class="flex-row">
                            <b-navbar-brand id="meanager" to="/">
                                <span class="nav-linkx">MEANager</span>
                            </b-navbar-brand>
                            <b-badge id="balance">{{ balance | NiceAmount }}</b-badge>
                        </div>

                        <b-collapse is-nav id="nav_collapse">
                            <b-navbar-nav class="ml-auto">
                                <router-link tag="li" class="nav-item" to="/shops" v-on:click.native="nextStep()">
                                    <a class="nav-link">{{ 'SHOPS' | translate }}</a>
                                    <div v-if="step.id === 1" class="tutorial step popover bs-popover-bottom" role="tooltip" id="popover-step1" style="top:42px;left:-70px;width:200px;display: block;">
                                        <div class="arrow" style="left: 50%;"></div>
                                        <h3 class="popover-header">{{ $t('TUTORIAL_STEP1_TITLE') }}</h3>

                                        <div class="popover-body">{{ $t('TUTORIAL_STEP1_TEXT') }}</div>
                                    </div>
                                    <div v-if="step.id === 10" class="tutorial step popover bs-popover-bottom" role="tooltip" id="popover-step10" style="top:42px;left:-70px;width:200px;display: block;">
                                        <div class="arrow" style="left: 50%;"></div>
                                        <h3 class="popover-header">{{ step.title }}</h3>

                                        <div class="popover-body">{{ step.text }}</div>
                                    </div>
                                </router-link>
                                <router-link tag="li" class="nav-item" to="/upgrades">
                                    <a class="nav-link">{{ 'UPGRADES' | translate }}</a>
                                </router-link>
                                <router-link tag="li" class="nav-item" to="/managers" v-on:click.native="nextStepManager()">
                                    <a class="nav-link">{{ 'MANAGERS' | translate }}</a>
                                    <div v-if="step.id === 8" class="tutorial step popover bs-popover-bottom" role="tooltip" id="popover-step8" style="top:42px;left:-70px;width:200px;display: block;">
                                        <div class="arrow" style="left: 50%;"></div>
                                        <h3 class="popover-header">{{ step.title }}</h3>

                                        <div class="popover-body">{{ step.text }}</div>
                                    </div>
                                </router-link>
                                <router-link tag="li" class="nav-item" to="/achievements">
                                    <a class="nav-link">{{ 'ACHIEVEMENTS' | translate }}</a>
                                </router-link>

                                <b-nav-item-dropdown right>
                                    <template slot="text">
                                        <span style="font-weight: bold;">Meta</span>
                                    </template>
                                    <b-link class="dropdown-item" @click="toggleMute">
                                        {{ 'SOUND' | translate }} <i class="fa" :class="{'fa-volume-up': soundEnabled, 'fa-volume-off': !soundEnabled}"></i>
                                    </b-link>
                                    <router-link tag="a" class="dropdown-item" to="/settings" v-if="user.isLoggedIn">
                                        {{ $t('HELLO', {name: user.name}) }} <i class="fa fa-cog"></i>
                                    </router-link>
                                    <router-link tag="a" class="dropdown-item" to="/signup" v-if="!user.isLoggedIn">
                                        {{ 'SIGNUP' | translate }}
                                    </router-link>
                                    <router-link tag="a" class="dropdown-item" to="/login" v-if="!user.isLoggedIn">
                                        {{ 'LOGIN' | translate }}
                                    </router-link>
                                    <b-link class="dropdown-item" @click="logout()" v-if="user.isLoggedIn">
                                        {{ 'LOGOUT' | translate }}
                                    </b-link>
                                </b-nav-item-dropdown>
                            </b-navbar-nav>
                        </b-collapse>
                    </b-navbar>
                </div>
            </div>
        </div>
        <messages></messages>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Messages from './Messages.vue';
import store from '../store';
import AuthService from '../services/auth.service';
export default {
    name: 'pageHeader',
    data() {
        return { };
    },
    computed: mapGetters({
        balance:      'totalBalance',
        soundEnabled: 'soundEnabled',
        user:         'user',
        step:         'step'
    }),
    components: {
        Messages
    },
    methods: {
        toggleMute() {
            store.commit({ type: 'TOGGLE_MUTE' });
            return false;
        },
        logout() {
            const auth = new AuthService();
            auth.logout()
                .then(() => {
                    store.commit('USER_LOGOUT');
                    this.$router.push({ path: '/' });
                })
                .catch(() => {
                    store.commit('USER_LOGOUT');
                    this.$router.push({ name: 'Login' });
                });
        },
        nextStep() {
            if (this.step.id === 10) {
                store.dispatch('setStep', 11);
            } else if (this.step.id === 1) {
                store.dispatch('setStep', 2);
            }
        },
        nextStepManager() {
            if (this.step.id === 8) {
                store.dispatch('setStep', 9);
            }
        }
    }
};
</script>

<style scoped lang="less">
@navbar-default-link-active-color: #555;
#header {
    height: 72px;
    .alert {
        position: relative;
    }
    button.close {
        font-size:   2.4em;
        line-height: 1em;
        right:       5px;
    }
}

#meanager {
    font-weight: bold;
    font-size: 1.1rem;
}

#balance {
    font-size: 1.1rem;
}

.navbar {
    background-color: #fff;
    border-color: #ddd;
    padding-left: 0;
    padding-right: 0;

    .container {
        padding: 0;
    }
    #locale-wrap {
        margin: 7px 0 0 10px;
    }

    .router-link-active a {
        color: rgba(0, 0, 0, 0.7);
    }
    .nav-item {
        position: relative;
    }
    /*
    .navbar-nav > li {
        position: relative;
    }
    .navbar-nav > li > a {
        padding: 16px 10px;
    }
    a.active, a:focus {
        color:            @navbar-default-link-active-color;
        background-color: @navbar-default-link-active-color;
    }
    */
}
</style>
